import { createAction } from 'redux-actions';

export const ADD_DEFAULT_PROD_CLASS = 'ADD_DEFAULT_PROD_CLASS';

export default createAction(ADD_DEFAULT_PROD_CLASS);
